/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CurrencyModel } from './currencyModel';
import { RestaurantModelPrefTimeZone } from './restaurantModelPrefTimeZone';
import { SmartDineImage } from './smartDineImage';

export interface RestaurantModel { 
    restaurantId?: string;
    restaurantCode?: string;
    name?: string;
    description?: string;
    iconUrl?: string;
    gstIN?: string;
    iconImage?: SmartDineImage;
    restaurantImages?: Array<SmartDineImage>;
    restaurantStatus?: RestaurantModel.RestaurantStatusEnum;
    validUpto?: Date;
    maxNoOfTables?: number;
    maxNoOfRestaurantBranches?: number;
    active?: boolean;
    restaurantSubscriptionEntityId?: string;
    fssai?: string;
    prefCurrencyCode?: string;
    prefTimeZone?: RestaurantModelPrefTimeZone;
    prefCurrency?: CurrencyModel;
    prefTimeZoneId?: string;
}
export namespace RestaurantModel {
    export type RestaurantStatusEnum = 'DRAFT' | 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED' | 'PUBLISHED' | 'UNPUBLISHED' | 'PAYMENT_PENDING';
    export const RestaurantStatusEnum = {
        DRAFT: 'DRAFT' as RestaurantStatusEnum,
        PENDINGAPPROVAL: 'PENDING_APPROVAL' as RestaurantStatusEnum,
        APPROVED: 'APPROVED' as RestaurantStatusEnum,
        REJECTED: 'REJECTED' as RestaurantStatusEnum,
        PUBLISHED: 'PUBLISHED' as RestaurantStatusEnum,
        UNPUBLISHED: 'UNPUBLISHED' as RestaurantStatusEnum,
        PAYMENTPENDING: 'PAYMENT_PENDING' as RestaurantStatusEnum
    };
}